import { useState, useEffect } from 'react';
import { axiosApi } from '../../api/setupApi';

const useGetAllUser = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUsers = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const { data } = await axiosApi.get('/auth/getAll_users');
      setUsers(data);
    } catch (err) {
      console.error('Error in useGetAllUsers:', err.message);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return { users, isLoading, error, refetch: fetchUsers };
};

export default useGetAllUser;
